import React from 'react';
import cn from 'classnames';
import styles from "./InlineControl.module.scss";
import { Typography } from "../../Typography";
import { TableList } from "../TableList";
export function InlineButton(props) {
  const {
    className,
    children,
    error,
    ref,
    testid,
    tooltipProps,
    disabled,
    onClick
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.root, className),
    "data-testid": testid
  }, /*#__PURE__*/React.createElement(Typography, {
    ellipsis: true,
    tooltipProps: tooltipProps
  }, children, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.frame, styles.absolutePosition, {
      [styles.frameDisabled]: disabled,
      [styles.error]: error,
      [TableList.classes.showOnRowHover]: !error
    })
  }, /*#__PURE__*/React.createElement("button", {
    ref: ref,
    "data-testid": testid && "".concat(testid, "-btn"),
    onClick: onClick,
    disabled: disabled,
    className: cn(styles.formElement, styles.absolutePosition)
  }))));
}